import { render, staticRenderFns } from "./faceMonitor2.vue?vue&type=template&id=c05f87f6&"
import script from "./faceMonitor2.vue?vue&type=script&lang=js&"
export * from "./faceMonitor2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports